var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQoute({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_122779",
    "data-name": "Group 122779",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#1b4a83"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-quote-left",
    "data-name": "Icon awesome-quote-left",
    d: "M9.916,7.037H8.206V5.669A1.369,1.369,0,0,1,9.574,4.3h.171a.512.512,0,0,0,.513-.513V2.763a.512.512,0,0,0-.513-.513H9.574A3.418,3.418,0,0,0,6.155,5.669V10.8a1.026,1.026,0,0,0,1.026,1.026H9.916A1.026,1.026,0,0,0,10.942,10.8V8.063A1.026,1.026,0,0,0,9.916,7.037Zm-6.155,0H2.052V5.669A1.369,1.369,0,0,1,3.419,4.3H3.59A.512.512,0,0,0,4.1,3.789V2.763A.512.512,0,0,0,3.59,2.25H3.419A3.418,3.418,0,0,0,0,5.669V10.8a1.026,1.026,0,0,0,1.026,1.026H3.761A1.026,1.026,0,0,0,4.787,10.8V8.063A1.026,1.026,0,0,0,3.761,7.037Z",
    transform: "translate(8.529 6.963)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQoute);
export default __webpack_public_path__ + "static/media/qoute.ca5554641be6e2824d886aa4c316a86c.svg";
export { ForwardRef as ReactComponent };